/*eslint no-useless-escape: "off"*/
/* eslint-disable */
import React, { Component } from 'react'
import NavItem from '../components/NavItem'
import Config from '../config/app';
import firebase from './../config/database'
import MasterUI from './../ui/template/Master'
import T from './../translations/translate'
var md5 = require('md5');
import { connect } from 'react-redux'
import { Redirect } from 'react-router'

//const CircularJSON = require('circular-json')

const ConditionalWrap = ({ condition, wrap, children }) => condition ? wrap(children) : children;


/**
 * Master View,  Represents the side/main navigation
 */
class Master extends Component {

  constructor(props) {
    super(props);
    this.state = { user: {}, empty: 0 };
    this.handleLogout = this.handleLogout.bind(this);
    this.printMenuItem = this.printMenuItem.bind(this);
  }
  componentWillMount() {
    console.log("In master.js");
    this.props.logindoneevent(this.props.route.user, this.props.params.sub)
      .then(data => {
        console.log("Result from firebase");
        console.log(data);
        if (data.empty == 1) {
          this.props.router.push('/#')
        }
        this.setState({
          empty: data.empty
        })
      })
  }



  /**
   * Logout function
   * @param {Event} e 
   */
  handleLogout(e) {
    e.preventDefault();

    console.log('The link was clicked.');
    firebase.app.auth().signOut();
  }

  /**
   * Validate URL
   * @param {String} str 
   */
  ValidURL(str) {
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if (!regex.test(str)) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * Print menu items
   * @param {Oject} menu 
   */
  printMenuItem(menu, fromsub) {
    var navigation = this.props.events[this.props.params.sub].navigation;
    var menus = [];
    // console.log("In print menu item");
    if (navigation != undefined) {
      menus = navigation.menus;
    }
    if (menu.eventsub) {
      var found = false;
      menus.map(m => {
        if (m.type == menu.link) {
          found = true;
        }
      })
      if (!found) {
        return;
      }
    }

    var menuPath = this.ValidURL(menu.path) ? menu.path : menu.path.replace(/\//g, Config.adminConfig.urlSeparator);
    if (menu.addevent && menu.subMenus) {
      menuPath = menuPath + "/" + this.props.params.sub;
    } else if (menu.addevent) {
      menuPath = menuPath + this.props.params.sub;
    }

    if (menu.subMenus && menu.subMenus.length > 0) {

      return (
        <li key={menu.name}>
          <a data-toggle="collapse" href={"#" + menuPath} className="collapsed" aria-expanded="false">
            <i className="material-icons">{menu.icon}</i>
            <ConditionalWrap
              condition={Config.designSettings.sideMenuTextWrappedInParagraph}
              wrap={children => <p>{children}</p>}
            >
              <span>{T.td(menu.name)}
                <b className="caret"></b></span></ConditionalWrap>
          </a>
          <div className="collapse" id={menuPath} aria-expanded="false">
            <ul className="nav">
              {menu.subMenus.map(this.printMenuItem, true)}
            </ul>
          </div>
        </li>
      )
    } else {
      // console.log("h");
      // console.log(menuPath);
      var link = menu.link;
      if (menuPath != "") {
        link = link + "/" + menuPath
      }
      return (<NavItem
        key={menu.link + "/" + menuPath}
        index={menu.isIndex}
        onlyActiveOnIndex={menu.isIndex}
        menuPath={menuPath}
        to={link}
      >
        <i className="material-icons">{menu.icon}</i>
        <ConditionalWrap
          condition={Config.designSettings.sideMenuTextWrappedInParagraph}
          wrap={children => <p>{children}</p>}
        >

          <span>{T.td(menu.name)}</span></ConditionalWrap>
      </NavItem>)
    }

  }


  /**
   * Main render function
   */
  render() {

    //Prepare the environment
    if (this.props.params && this.props.params.sub && (this.props.location.pathname.indexOf('sections') === 1 || this.props.location.pathname.indexOf('home') === 1)) {
      // console.log(JSON.stringify(this.props.location))
      if (this.props.params.sub !== "null") {
        //Used for the app builder
        var pathToApps = Config.notSaaSAppsPath + "/" + this.props.params.sub;


        Config.appEditPath = pathToApps;
      }
    }

    if (this.props.location.pathname.indexOf('chome') === 1) {
      console.log(JSON.stringify(this.props.location))
      if (this.props.params.sub !== "null") {
        //Used for the app builder
        var pathToApps = Config.notSaaSAppsPath + "/" + this.props.params.sub;


        Config.appEditPath = pathToApps;
      }
    }

    //Additional syles that you can send to your template. ex. imageSetup
    var bgStyle = {
      backgroundImage: 'require(../../assets/img/' + Config.adminConfig.design.sidebarBg + ')',
    };
    if (this.state.empty == 2) {
      // console.log("Data saved in redux");
      return (
        <MasterUI
          userPhoto={this.props.user.photoURL ? this.props.user.photoURL : 'http://www.gravatar.com/avatar/' + md5(this.props.user.email + "") + "?s=512"}
          user={this.props.user}
          logout={this.handleLogout}
          printMenuItem={this.printMenuItem}
          additionalStyle1={bgStyle}
          children={this.props.children}
          ValidURL={this.ValidURL}

          checkIsSuperAdmin={true}

          //languages
          countries={this.props.route.currentLangData.availableLaguages}
          defaultCountry={this.props.route.currentLangData.currentLang}
        />
      )
    } else if (this.state.empty == 1) {
      return <div></div>
    } else {
      console.log("Show loading screen");
      return (
        <div id="fuse-splash-screen">
          <div className="center">
            <div className="logo">
              <img src="assets/img/xcape.png" alt="logo" />
            </div>
            <div className="spinner-wrapper">
              <div className="spinner">
                <div className="inner">
                  <div className="gap" />
                  <div className="left">
                    <div className="half-circle" />
                  </div>
                  <div className="right">
                    <div className="half-circle" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

  }
}


const mapStateToProps = state => ({
  // todos: getVisibleTodos(state.todos, state.visibilityFilter)
  events: state.eventmodel.mainappdata.events,
  user: state.eventmodel.mainappdata.user
})

const mapDispatchToProps = dispatch => ({
  // toggleTodo: id => dispatch(toggleTodo(id))
  logindoneevent: dispatch.eventmodel.logindoneevent,

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Master)


// WEBPACK FOOTER //
// ./src/containers/Master.js